import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div className="notFound__compass">
    <div className="notFound__compass_shape">
      <p>
        404 - Not Found!
        <br />
        <Link className="notFound__compass_shape-goHome" to="/">
          Go Home
        </Link>
      </p>
    </div>
  </div>
);

export default NotFound;
